import { PageLoading } from "@ant-design/pro-layout";
import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

export interface IRouteConfig {
  path: string | string[];
  exact?: boolean;
  component?: React.ComponentType;
  redirect?: boolean;
}

export interface IRouteMapProps {
  config: IRouteConfig[];
}

const RouteMap: React.FC<IRouteMapProps> = ({ config }) => {
  return (
    <Suspense fallback={<PageLoading />}>
      <Switch>
        {config.map((route) => {
          const { path, exact = false, component, redirect } = route;
          if (redirect && !Array.isArray(path)) {
            return <Redirect key={`redirect-${path}`} to={path} />;
          }
          return (
            <Route
              path={path}
              key={String(path)}
              exact={exact}
              component={component}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
};

export default RouteMap;
